import { createApiAction } from 'src/api';

export const GET_SARS_START = 'account/get_sars_start';
export const GET_SARS_SUCCESS = 'account/get_sars_success';
export const GET_SARS_FAILURE = 'account/get_sars_failure';

export const ADD_SAR_START = 'account/add_sar_start';
export const ADD_SAR_SUCCESS = 'account/add_sar_success';
export const ADD_SAR_FAILURE = 'account/add_sar_failure';

export const ADD_LOAN_START = 'account/add_loan_start';
export const ADD_LOAN_SUCCESS = 'account/add_loan_success';
export const ADD_LOAN_FAILURE = 'account/add_loan_failure';

export const UPDATE_LOAN_START = 'account/update_loan_start';
export const UPDATE_LOAN_SUCCESS = 'account/update_loan_success';
export const UPDATE_LOAN_FAILURE = 'account/update_loan_failure';

export const DELETE_LOAN_START = 'account/delete_loan_start';
export const DELETE_LOAN_SUCCESS = 'account/delete_loan_success';
export const DELETE_LOAN_FAILURE = 'account/delete_loan_failure';

export const getSars = (account, loan) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${account}/loans/${loan}/sar/`,
      method: 'GET',
    },
    [GET_SARS_START, GET_SARS_SUCCESS, GET_SARS_FAILURE]
  );

export const addLoanSar = ({
  account,
  loan,
  sarId,
  sarFilerName,
  sarFiledDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${account}/loans/${loan}/sar/`,
      method: 'POST',
      body: {
        sar_fincen_id: sarId,
        sar_filer_name: sarFilerName,
        sar_filed_date: sarFiledDate,
      },
    },
    [ADD_SAR_START, ADD_SAR_SUCCESS, ADD_SAR_FAILURE]
  );

export const addAccountLoan = ({
  accountId,
  loanAnnualSales,
  loanBuisnessNetIncome,
  loanBusinessNetEquity,
  loanNumberOfEmployees,
  loanDecApplicantOblig,
  loanDecApplicantTaxesPastDue,
  loanDecApplicantTaxesPastDueAmt,
  loanDecApplicantTaxesPastDueOwedTo,
  loanDecOtherAssetsPledged,
  loanDecOtherCreditPastDue,
  loanDecApplicantFelon,
  loanDecApplicantPolitical,
  loanDecApplicantPoliticalNameOfEmployee,
  loanDecApplicantEmployeeOfBank,
  loanDecApplicantEmployeeOfBankEmployee,
  loanDecApplicantFinInstEmployee,
  loanDecApplicantFinInstEmployeeFi,
  loanDecWillFiftyComeFromLease,
  loanDecWillFiftyComeFromSale,
  loanIsArchived,
  loanIsApproved,
  loanIsDenied,
  loanSubmittedToFinancialInstitution,
  loanAddedDate,
  loanAutomaticPaymentChecking,
  loanIdentifier,
  loanType,
  loanAmount,
  loanRepaymentPeriod,
  loanUseOfFunds,
  loanPaymentAmount,
  loanPaymentMethod,
  loanClosedDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/loans/`,
      method: 'POST',
      body: {
        loan_annual_sales: loanAnnualSales,
        loan_buisness_net_income: loanBuisnessNetIncome,
        loan_business_net_equity: loanBusinessNetEquity,
        loan_number_of_employees: loanNumberOfEmployees,
        loan_dec_applicant_oblig: loanDecApplicantOblig,
        loan_dec_applicant_taxes_past_due: loanDecApplicantTaxesPastDue,
        loan_dec_applicant_taxes_past_due_amt: loanDecApplicantTaxesPastDueAmt,
        loan_dec_applicant_taxes_past_due_owed_to: loanDecApplicantTaxesPastDueOwedTo,
        loan_dec_other_assets_pledged: loanDecOtherAssetsPledged,
        loan_dec_other_credit_past_due: loanDecOtherCreditPastDue,
        loan_dec_applicant_felon: loanDecApplicantFelon,
        loan_dec_applicant_political: loanDecApplicantPolitical,
        loan_dec_applicant_political_name_of_employee: loanDecApplicantPoliticalNameOfEmployee,
        loan_dec_applicant_employee_of_bank: loanDecApplicantEmployeeOfBank,
        loan_dec_applicant_employee_of_bank_employee: loanDecApplicantEmployeeOfBankEmployee,
        loan_dec_applicant_fin_inst_employee: loanDecApplicantFinInstEmployee,
        loan_dec_applicant_fin_inst_employee_fi: loanDecApplicantFinInstEmployeeFi,
        loan_dec_will_fifty_come_from_lease: loanDecWillFiftyComeFromLease,
        loan_dec_will_fifty_come_from_sale: loanDecWillFiftyComeFromSale,
        loan_is_archived: loanIsArchived,
        loan_is_approved: loanIsApproved,
        loan_is_denied: loanIsDenied,
        loan_submitted_to_financial_institution: loanSubmittedToFinancialInstitution,
        loan_added_date: loanAddedDate,
        loan_payment_amount: loanPaymentAmount,
        loan_payment_method: loanPaymentMethod,
        loan_closed_date: loanClosedDate,
        loan_automatic_payment_checking: loanAutomaticPaymentChecking,
        loan_identifier: loanIdentifier,
        loan_type: loanType,
        loan_amount: loanAmount,
        loan_repayment_period: loanRepaymentPeriod,
        loan_use_of_funds: loanUseOfFunds,
      },
    },
    [ADD_LOAN_START, ADD_LOAN_SUCCESS, ADD_LOAN_FAILURE]
  );

export const updateAccountLoan = ({
  accountId,
  loanId,
  loanAnnualSales,
  loanBuisnessNetIncome,
  loanBusinessNetEquity,
  loanNumberOfEmployees,
  loanDecApplicantOblig,
  loanDecApplicantTaxesPastDue,
  loanDecApplicantTaxesPastDueAmt,
  loanDecApplicantTaxesPastDueOwedTo,
  loanDecOtherAssetsPledged,
  loanDecOtherCreditPastDue,
  loanDecApplicantFelon,
  loanDecApplicantPolitical,
  loanDecApplicantPoliticalNameOfEmployee,
  loanDecApplicantEmployeeOfBank,
  loanDecApplicantEmployeeOfBankEmployee,
  loanDecApplicantFinInstEmployee,
  loanDecApplicantFinInstEmployeeFi,
  loanDecWillFiftyComeFromLease,
  loanDecWillFiftyComeFromSale,
  loanIsArchived,
  loanIsApproved,
  loanIsDenied,
  loanSubmittedToFinancialInstitution,
  loanAddedDate,
  loanAutomaticPaymentChecking,
  loanIdentifier,
  loanType,
  loanAmount,
  loanRepaymentPeriod,
  loanUseOfFunds,
  loanPaymentAmount,
  loanPaymentMethod,
  loanClosedDate,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/loans/${loanId}/`,
      method: 'PUT',
      body: {
        loan_annual_sales: loanAnnualSales,
        loan_buisness_net_income: loanBuisnessNetIncome,
        loan_business_net_equity: loanBusinessNetEquity,
        loan_number_of_employees: loanNumberOfEmployees,
        loan_dec_applicant_oblig: loanDecApplicantOblig,
        loan_dec_applicant_taxes_past_due: loanDecApplicantTaxesPastDue,
        loan_dec_applicant_taxes_past_due_amt: loanDecApplicantTaxesPastDueAmt,
        loan_dec_applicant_taxes_past_due_owed_to: loanDecApplicantTaxesPastDueOwedTo,
        loan_dec_other_assets_pledged: loanDecOtherAssetsPledged,
        loan_dec_other_credit_past_due: loanDecOtherCreditPastDue,
        loan_dec_applicant_felon: loanDecApplicantFelon,
        loan_dec_applicant_political: loanDecApplicantPolitical,
        loan_dec_applicant_political_name_of_employee: loanDecApplicantPoliticalNameOfEmployee,
        loan_dec_applicant_employee_of_bank: loanDecApplicantEmployeeOfBank,
        loan_dec_applicant_employee_of_bank_employee: loanDecApplicantEmployeeOfBankEmployee,
        loan_dec_applicant_fin_inst_employee: loanDecApplicantFinInstEmployee,
        loan_dec_applicant_fin_inst_employee_fi: loanDecApplicantFinInstEmployeeFi,
        loan_dec_will_fifty_come_from_lease: loanDecWillFiftyComeFromLease,
        loan_dec_will_fifty_come_from_sale: loanDecWillFiftyComeFromSale,
        loan_is_archived: loanIsArchived,
        loan_is_approved: loanIsApproved,
        loan_is_denied: loanIsDenied,
        loan_submitted_to_financial_institution: loanSubmittedToFinancialInstitution,
        loan_added_date: loanAddedDate,
        loan_automatic_payment_checking: loanAutomaticPaymentChecking,
        loan_identifier: loanIdentifier,
        loan_type: loanType,
        loan_amount: loanAmount,
        loan_repayment_period: loanRepaymentPeriod,
        loan_use_of_funds: loanUseOfFunds,
        loan_payment_amount: loanPaymentAmount,
        loan_payment_method: loanPaymentMethod,
        loan_closed_date: loanClosedDate,
      },
    },
    [UPDATE_LOAN_START, UPDATE_LOAN_SUCCESS, UPDATE_LOAN_FAILURE]
  );

export const deleteAccountLoan = ({ accountId, loanId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/loans/${loanId}/`,
      method: 'DELETE',
    },
    [DELETE_LOAN_START, DELETE_LOAN_SUCCESS, DELETE_LOAN_FAILURE]
  );
};
